/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubjectStepModel from 'cio/models/subject-step';
import { SerializedLegacyMessageFilter } from 'cio/types/conditions/legacy-filter';
import { isPresent } from '@ember/utils';
import CampaignModel from 'cio/models/campaign';

interface MatchArgs {
  step: SubjectStepModel;
  description: string;
  campaign?: CampaignModel;
}

type ActivityQueryParams = {
  type: string;
  name?: string;
  selected?: string;
};

export default class Match extends Component<MatchArgs> {
  get subjectEventDataConditions(): SerializedLegacyMessageFilter[] | null {
    if (this.args.campaign?.isWebhookTriggered) {
      return null;
    }

    let eventData = this.args.step?.subject?.eventData;
    if (isPresent(eventData)) {
      return [
        {
          // @ts-ignore: isPresent is doing an unrecognized null & length check
          event: { name: eventData.name, type: eventData.type },
          type: 'message',
          within: 0,
          inverse: false,
          times: 1,
        },
      ];
    }

    return null;
  }

  get activityLogFilterParams(): ActivityQueryParams {
    let filterParams: ActivityQueryParams = {
      type: 'event',
    };

    if (isPresent(this.subjectEventDataConditions)) {
      filterParams.name = this.subjectEventDataConditions?.[0].event.name;
      filterParams.selected = this.args.step.subject?.eventData?.id;
    }

    return filterParams;
  }
}
